import React, {useState, useRef, useEffect} from "react";
import {Routes, Route} from "react-router-dom";
import Layout from "./components/Layout";
import "./App.css";
import Home from './components/Home';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Project from "./components/Project";
import NotFound from './components/NotFound';

const App = () => {
  const topRef = useRef(null);
  
  const projectsList = [
    {
      id: 0,
      image: 'images/portfolio/mobile/image-portfolio-calculator.jpg',
      title: "Tip Calculator", 
      description: "This project was built in HTML, CSS and JavaScript. I had mobile and desktop designs to work to and built it so that it was fully-responsive. I took a mobile-first approach and used modern CSS like Flexbox for layout purposes.",
      type: "Interaction Design / Front End Development",
      designedWith: "HTML / CSS / JS",
      bio: "This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.",
      preview1: 'images/detail/desktop/tipcalculator-preview1.jpg',
      preview2: 'images/detail/desktop/tipcalculator-preview2.jpg'
    }, 
    
    {
      id: 1,
      image: 'images/portfolio/mobile/entertainment1.jpg',
      title: "Entertainment", 
      description: "This project required me to build a fully-responsive page to the designs provided. I used React, HTML5, along with CSS Flex and JavaScript for the areas that required interactivity.",
      type: "Interaction Design / Front End Development",
      designedWith: "REACT / HTML / CSS / JS",
      bio: "This project was a front - end challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real - world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.",
      preview1: 'images/portfolio/mobile/entertainment2.jpg',
      preview2: 'images/portfolio/mobile/entertainment3.jpg'
    }, 
    
    {
      id: 2,
      image: 'images/detail/desktop/image-insure-preview-1@2x.jpg',
      title: "Insure", 
      description: "This was a small project which mostly consisted of HTML and CSS. I built a fully-responsive landing page. The only JavaScript this project required was to enable the toggling of the mobile navigation.",
      type: "Interaction Design / Front End Development",
      designedWith: "HTML / CSS / JS",
      bio: "This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.",
      preview1: 'images/detail/desktop/image-insure-hero@2x.jpg',
      preview2: 'images/detail/desktop/image-insure-preview-2@2x.jpg'
    },
    
    {
      id: 3,
      image: 'images/detail/desktop/image-fylo-preview-1@2x.jpg',
      title: "Fylo", 
      description: "This project was built in pure HTML and CSS. I had mobile and desktop designs to work to and built it so that it was fully-responsive. I took a mobile-first approach and used modern CSS like Flexbox and Grid for layout purposes.",
      type: "Interaction Design / Front End Development",
      designedWith: "HTML / CSS / JS",
      bio: "This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.",
      preview1: 'images/detail/desktop/image-fylo-hero@2x.jpg',
      preview2: 'images/detail/desktop/image-fylo-preview-2@2x.jpg'
    }
  ];
  
  
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen ((prev) => !prev);
  }

  function handleMenuClick(e){
    const element = topRef.current;
    
      if (element) {
        const styles = getComputedStyle(element);
        const marginTop = parseFloat(styles.marginTop); // calc(...) is resolved into a px value
        const top = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: top - marginTop, // Adjust for actual resolved margin
          behavior: 'smooth'
        });
      }
      
      if(menuOpen){
        toggleMenu();
      }
    
    
  }
  
    return (
          <>
            <Routes>
              <Route path="/" element={<Layout topRef={topRef} menuOpen={menuOpen} toggleMenu={toggleMenu} handleMenuClick={handleMenuClick} />}>
                <Route index element={<Home handleMenuClick={handleMenuClick} />}></Route>
                <Route path="portfolio" element={<Portfolio handleMenuClick={handleMenuClick} projectsList={projectsList} />}></Route>
                <Route path="contact" element={<Contact />}></Route>
                <Route path="portfolio/:projectName" element={<Project handleMenuClick={handleMenuClick} projectsList={projectsList} />}></Route>
              </Route>
              <Route path="*" element={<NotFound />}></Route>
            </Routes>
          </>
        );
      }
    
    export default App;
